/** 未覆盖权限所有字段，可补充 */
export var OWNER_PERMISSIONS = {
  isAuth: true,
  isAdmin: true,
  canAbout: true,
  canAddUser: true,
  canComment: true,
  canCopy: true,
  canCopyDoc: true,
  canEdit: true,
  canExport: true,
  canTransfer: true,
  canEditTitle: true,
  canViewHistory: true,
  canSetLinkExp: true,
  canPrint: true,
  canView: true,
  canSearch: true,
  canShare: true,
  canTranslate: true,
  canViewImage: true,
  canWatermark: true,
  canEditCollab: true,
  canViewCollab: true,
  canViewPrivSetting: true,
  canDelete: true,
  canCreateFile: true,
  canCreateFolder: true
};

/**
 * 用户权限角色. 表示用户在某个文件或文件夹中的权限角色.
 *
 * 注意: 权限角色的数值虽然看起来有一定的顺序, 但实际上没有, 不可使用 >= 等运算符进行数值比较. (percychen)
 */
export var UserRole = /*#__PURE__*/function (UserRole) {
  UserRole[UserRole["Unauthorized"] = 0] = "Unauthorized";
  UserRole[UserRole["Readable"] = 1] = "Readable";
  UserRole[UserRole["Editable"] = 2] = "Editable";
  UserRole[UserRole["Fillable"] = 3] = "Fillable";
  UserRole[UserRole["AllowExecute"] = 4] = "AllowExecute";
  UserRole[UserRole["AllowExtern"] = 10] = "AllowExtern";
  UserRole[UserRole["Inherit"] = 20] = "Inherit";
  UserRole[UserRole["Admin"] = 1024] = "Admin";
  UserRole[UserRole["Owner"] = 2048] = "Owner";
  return UserRole;
}({});
//# sourceMappingURL=permission.js.map